/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
import {LifecycleHooksFeature, renderComponent, whenRendered} from './component';
import {ÉµÉµdefineComponent, ÉµÉµdefineDirective, ÉµÉµdefineNgModule, ÉµÉµdefinePipe, ÉµÉµsetComponentScope, ÉµÉµsetNgModuleScope} from './definition';
import {ÉµÉµCopyDefinitionFeature} from './features/copy_definition_feature';
import {ÉµÉµInheritDefinitionFeature} from './features/inherit_definition_feature';
import {ÉµÉµNgOnChangesFeature} from './features/ng_onchanges_feature';
import {ÉµÉµProvidersFeature} from './features/providers_feature';
import {ComponentDef, ComponentTemplate, ComponentType, DirectiveDef, DirectiveType, PipeDef, ÉµÉµComponentDefWithMeta, ÉµÉµDirectiveDefWithMeta, ÉµÉµFactoryDef, ÉµÉµPipeDefWithMeta} from './interfaces/definition';
import {getComponent, getDirectives, getHostElement, getRenderedText} from './util/discovery_utils';

export {ComponentFactory, ComponentFactoryResolver, ComponentRef, injectComponentFactoryResolver} from './component_ref';
export {ÉµÉµgetFactoryOf, ÉµÉµgetInheritedFactory} from './di';

// clang-format off
export {
  detectChanges,
  markDirty,
  store,
  tick,

  ÉµÉµattribute,
  ÉµÉµattributeInterpolate1,
  ÉµÉµattributeInterpolate2,
  ÉµÉµattributeInterpolate3,
  ÉµÉµattributeInterpolate4,
  ÉµÉµattributeInterpolate5,
  ÉµÉµattributeInterpolate6,
  ÉµÉµattributeInterpolate7,
  ÉµÉµattributeInterpolate8,
  ÉµÉµattributeInterpolateV,

  ÉµÉµclassMap,
  ÉµÉµclassMapInterpolate1,
  ÉµÉµclassMapInterpolate2,
  ÉµÉµclassMapInterpolate3,
  ÉµÉµclassMapInterpolate4,
  ÉµÉµclassMapInterpolate5,
  ÉµÉµclassMapInterpolate6,
  ÉµÉµclassMapInterpolate7,
  ÉµÉµclassMapInterpolate8,
  ÉµÉµclassMapInterpolateV,

  ÉµÉµclassProp,
  ÉµÉµcomponentHostSyntheticListener,

  ÉµÉµcontainer,
  ÉµÉµcontainerRefreshEnd,
  ÉµÉµcontainerRefreshStart,

  ÉµÉµdirectiveInject,
  ÉµÉµinvalidFactory,

  ÉµÉµelement,
  ÉµÉµelementContainer,
  ÉµÉµelementContainerEnd,

  ÉµÉµelementContainerStart,
  ÉµÉµelementEnd,

  ÉµÉµelementStart,
  ÉµÉµembeddedViewEnd,

  ÉµÉµembeddedViewStart,

  ÉµÉµgetCurrentView,
  ÉµÉµinjectAttribute,

  ÉµÉµlistener,

  ÉµÉµnamespaceHTML,
  ÉµÉµnamespaceMathML,
  ÉµÉµnamespaceSVG,

  ÉµÉµnextContext,

  ÉµÉµprojection,
  ÉµÉµprojectionDef,
  ÉµÉµhostProperty,
  ÉµÉµproperty,
  ÉµÉµpropertyInterpolate,
  ÉµÉµpropertyInterpolate1,
  ÉµÉµpropertyInterpolate2,
  ÉµÉµpropertyInterpolate3,
  ÉµÉµpropertyInterpolate4,
  ÉµÉµpropertyInterpolate5,
  ÉµÉµpropertyInterpolate6,
  ÉµÉµpropertyInterpolate7,
  ÉµÉµpropertyInterpolate8,
  ÉµÉµpropertyInterpolateV,

  ÉµÉµreference,

  // TODO: remove `select` once we've refactored all of the tests not to use it.
  ÉµÉµselect,
  ÉµÉµadvance,
  ÉµÉµstyleMap,

  ÉµÉµstyleProp,
  ÉµÉµstylePropInterpolate1,
  ÉµÉµstylePropInterpolate2,
  ÉµÉµstylePropInterpolate3,
  ÉµÉµstylePropInterpolate4,
  ÉµÉµstylePropInterpolate5,
  ÉµÉµstylePropInterpolate6,
  ÉµÉµstylePropInterpolate7,
  ÉµÉµstylePropInterpolate8,
  ÉµÉµstylePropInterpolateV,

  ÉµÉµstyleSanitizer,
  ÉµÉµtemplate,

  ÉµÉµtext,
  ÉµÉµtextInterpolate,
  ÉµÉµtextInterpolate1,
  ÉµÉµtextInterpolate2,
  ÉµÉµtextInterpolate3,
  ÉµÉµtextInterpolate4,
  ÉµÉµtextInterpolate5,
  ÉµÉµtextInterpolate6,
  ÉµÉµtextInterpolate7,
  ÉµÉµtextInterpolate8,
  ÉµÉµtextInterpolateV,

  ÉµÉµupdateSyntheticHostBinding,
} from './instructions/all';
export {RenderFlags} from './interfaces/definition';
export {CssSelectorList, ProjectionSlots} from './interfaces/projection';

export {
  ÉµÉµrestoreView,

  ÉµÉµenableBindings,
  ÉµÉµdisableBindings,
} from './state';

export {
  ÉµÉµi18n,
  ÉµÉµi18nAttributes,
  ÉµÉµi18nExp,
  ÉµÉµi18nStart,
  ÉµÉµi18nEnd,
  ÉµÉµi18nApply,
  ÉµÉµi18nPostprocess,
  getLocaleId,
  setLocaleId,
} from './i18n';

export {NgModuleFactory, NgModuleRef, NgModuleType} from './ng_module_ref';

export {
  AttributeMarker
} from './interfaces/node';

export {
  setClassMetadata,
} from './metadata';

export {
  ÉµÉµpipe,
  ÉµÉµpipeBind1,
  ÉµÉµpipeBind2,
  ÉµÉµpipeBind3,
  ÉµÉµpipeBind4,
  ÉµÉµpipeBindV,
} from './pipe';

export {
  ÉµÉµqueryRefresh,
  ÉµÉµviewQuery,
  ÉµÉµstaticViewQuery,
  ÉµÉµloadQuery,
  ÉµÉµcontentQuery,
  ÉµÉµstaticContentQuery
} from './query';

export {
  ÉµÉµpureFunction0,
  ÉµÉµpureFunction1,
  ÉµÉµpureFunction2,
  ÉµÉµpureFunction3,
  ÉµÉµpureFunction4,
  ÉµÉµpureFunction5,
  ÉµÉµpureFunction6,
  ÉµÉµpureFunction7,
  ÉµÉµpureFunction8,
  ÉµÉµpureFunctionV,
} from './pure_function';

export {ÉµÉµtemplateRefExtractor, ÉµÉµinjectPipeChangeDetectorRef} from './view_engine_compatibility_prebound';

export {ÉµÉµresolveWindow, ÉµÉµresolveDocument, ÉµÉµresolveBody} from './util/misc_utils';

// clang-format on

export {
  ComponentDef,
  ÉµÉµComponentDefWithMeta,
  ÉµÉµFactoryDef,
  ComponentTemplate,
  ComponentType,
  DirectiveDef,
  ÉµÉµDirectiveDefWithMeta,
  DirectiveType,
  ÉµÉµNgOnChangesFeature,
  ÉµÉµCopyDefinitionFeature,
  ÉµÉµInheritDefinitionFeature,
  ÉµÉµProvidersFeature,
  PipeDef,
  ÉµÉµPipeDefWithMeta,
  LifecycleHooksFeature,
  ÉµÉµdefineComponent,
  ÉµÉµdefineDirective,
  ÉµÉµdefineNgModule,
  ÉµÉµdefinePipe,
  getHostElement,
  getComponent,
  getDirectives,
  getRenderedText,
  renderComponent,
  ÉµÉµsetComponentScope,
  ÉµÉµsetNgModuleScope,
  whenRendered,
};

export {NO_CHANGE} from './tokens';
